import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { computed, ref, Ref } from 'vue'
import { getConfirmData, doOrderCreate, getOrderPayUrl, getNativePayStatus } from '@/api/vip'
import {requestToSnakeCase, responseToCamelCase, getDayOfYear } from '@/utils/utils.js'
import { useStore } from 'vuex'
import {getGoodsList, getSuccessTip} from './utils';
import {showPcpaperPopupaskBlank, clickPcpaperPopupaskBlank, pcpaperOrderPaid, pcpaperOrderPaidSuccess} from '@/trace/xesTrackVip.ts';
import { ElMessage } from 'element-plus'
import PayStatusDialog from "@/components/buyVip/PayStatusDialog.vue";
import { prop } from 'vue-class-component';

enum PayStatus {
    tobePaid = 1,
    inPayment = 2,
    paid = 3,
    paidFail = 4,
    paidCancel = 5
}

export default /*#__PURE__*/_defineComponent({
  __name: 'PayBtn',
  props: {
    goodsType: { default: () => 1 },
    styleObj: { default: () => ({}) },
    playLoad: { default: () => ({}) },
    paperData: { default: () => ({}) },
    position: { default: () => '' },
    entrance: { default: () => '' },
    currentIndex: { default: () => 0 }
  },
  emits: [ 'noLogin', 'handleBeforePay', 'handlePay', 'creatSuccess', 'creatFail', 'paySuccess', 'payFail', 'showNativePay', 'paymentResultQuery'],
  setup(__props: any, { expose: __expose, emit }) {

const props = __props;

/**
* @file payBtn.vue
* @title 支付按钮
* @author taomeili(taomeili@tal.com)
*
* @since 2023/5/16
*/
const store = useStore()
/**
 * 点击购买按钮：handlePay
 * 创建成功：creatSuccess
 * 创建失败：creatFail
 * 支付成功：paySuccess
 * 支付失败：payFail
 * 弹窗询问弹窗：showNativePay
 * 点击询问弹窗按钮：paymentResultQuery
 */


// 支付状态:0-待支付，1-待支付，2-支付中，3-支付成功，4-支付失败
const userInfo = computed(() => store.state.user.userInfo)
const payRecordNo: Ref<string> = ref('');
const resultQueryTimer = ref(null);
const queryResultCount = ref(0); // 查询次数

const confirmData = ref({}); // 会员确认订单数据(用于埋点)
const confirmDataPromotion = ref([]); // 会员确认订单促销数据(用于埋点)
const confirmDataSku = ref([]); // 会员确认订单sku数据(用于埋点)

const showPayStatusDialog = ref(false); // 是否显示支付状态询问弹窗
const paperVipInfo = computed(() => store.getters['user/paperVipInfo'])



// 询问支付结果弹窗回调
const paymentResultQuery = (content) => {
    clickPcpaperPopupaskBlank({
        content,
        position: props.position,
        entrance: props.entrance,
    })
    showPayStatusDialog.value = false;
    queryPayResult(payRecordNo.value, false);
    emit('paymentResultQuery')
};
const showNativePay = () => {
    emit('showNativePay');
    showPayStatusDialog.value = true;
    showPcpaperPopupaskBlank({
        position: props.position,
        entrance: props.entrance,
    })
}

const queryResultPerOneSec = (fn, payRecordNo = '') => {
    resultQueryTimer.value = setTimeout(() => {
        fn(payRecordNo);
    }, 5000);
};

const onFail = ({fn, payRecordNo = ''}) => {
    queryResultCount.value = queryResultCount.value + 1;
    if (queryResultCount.value > 60) {
        clearTimeout(resultQueryTimer.value);
        queryResultCount.value = 0;
        // loadingToast?.close();
        // alert('询问是否支付成功')
        showNativePay();
    }
    else {
        queryResultPerOneSec(fn, payRecordNo);
    }
};

const goodsPaySuccess = (equity_list = []) => {
    // 支付成功
    if (props.goodsType === 1) {
        // 埋点-会员订单支付成功-上报订单总数据
        const xesTrackInfo = xesTrackVipOrderCreatePay();
        pcpaperOrderPaidSuccess(xesTrackInfo)
        // 埋点-会员订单支付成功-展开上报spu_id/spu_name/sku_id/sku_name
        xesTrackVipOrderCreatePayInfo(pcpaperOrderPaidSuccess)

        ElMessage.success('支付成功')
        if (equity_list?.length) {
            const {msgs, hasOneYearCard} = getSuccessTip(equity_list || []);
            emit('paySuccess', {
                msgs,
                hasOneYearCard,
                goodsType: 1,
            });
            return;
        }
        // 支付成功但是激活失败-提示激活失败-找客服
        ElMessage.error('激活失败，请联系客服')
        return;
    } else {
        // 埋点-会员订单生成-上报订单总数据
        const xesTrackInfo = xesTrackPaperOrderCreatePay();
        pcpaperOrderPaidSuccess(xesTrackInfo)
        // 单卷支付成功
        emit('paySuccess', {
            msgs: [],
            goodsType: 2,
        });
    }
}

// 支付结果查询
const queryPayResult = (payRecordNo, isRepeat = true) => {
    getNativePayStatus({
        pay_record_no: payRecordNo,
        type: 2,
    }).then(res => {
        if (res.code) {
            onFail({fn: queryPayResult, payRecordNo});
            return;
        }
        const {pay_status, equity_list} = res?.data || {};
        console.log(pay_status, equity_list, '++++++++++++++++++++++')
        if (pay_status === PayStatus.paid) {
            // 支付成功
            // clearTimeout(resultQueryTimer.value);
            // queryResultCount.value = 0;
            // 更新权益接口数据
            store.dispatch('user/init')
            goodsPaySuccess(equity_list);
            return;
        } 
        if (pay_status === PayStatus.paidFail || pay_status === PayStatus.paidCancel) {
            ElMessage.error('支付失败')
            
            // 支付失败/取消
            // clearTimeout(resultQueryTimer.value);
            queryResultCount.value = 0;
            emit('payFail');
            // alert('支付失败')
            return;
        } else {
            if (!isRepeat) {
                emit('payFail');
                return;
            }
            onFail({fn: queryPayResult, payRecordNo});
            queryResultCount.value > 60 && showNativePay();
            // queryResultCount.value > 60 && alert('弹窗询问是否支付成功')
        }
        
    }).catch(err => {
        console.log(err)
        if (!isRepeat) {
            emit('payFail');
            return;
        }
        onFail({fn: queryPayResult, payRecordNo});
    })
}
// 简化购买会员弹窗会员支付逻辑：未登录点击去购买，去登录 登录后直接生成订单跳转收银台页面
const handlePay = () => {
    emit('handleBeforePay');
    // 去登陆
    if (!userInfo.value) {
        const xesTrackVipInfo = JSON.stringify({
            position: props.position,
            entrance: props.entrance,
        });
        window.sessionStorage.setItem('isReserveShowVip', 'true')
        window.sessionStorage.setItem('isDirectPay', !!(props.goodsType === 1)) // 会员弹窗登录后直接去支付
        window.sessionStorage.setItem('directPayInfo', JSON.stringify({playLoad: props.playLoad, currentIndex: props.currentIndex})) // 会员弹窗登录后直接去支付
        window.sessionStorage.setItem('xesTrackVipInfo', xesTrackVipInfo);
        store.dispatch('closeVipDialog')
        store.dispatch('openLogin')
        return
    }
    // 试卷
    if (props.goodsType === 2) {
        emit('handlePay')
        const { skus, promotion } = props.playLoad
        const params = {
            tal_id: userInfo.value?.tal_id,
            mall_id: 1,
            source: 11,
            skus: skus || [],
            promotion: promotion || null,
        }
        handleDoOrderCreate(params)
        return;
    }
    // vip
    handleGetConfirmData()
}

// 根据支付单号获取收银台链接
const getPayParams = async (recordNo: string) => {
    const url = `${window.location.origin}/paper`;
    getOrderPayUrl({
        pay_record_no: recordNo,
        pay_type: 7,
        pay_method: 0,
        return_url: url,
        cancel_url: url,
    }).then(res => {
        if (res.code) {
            return
        }
        const {pay_data} = res?.data
        const payUrl = pay_data || ''
        // // 轮询查询支付结果
        // const trim = setTimeout(() => {
        //     queryPayResult(recordNo);
        //     clearTimeout(trim);
        // }, 5000);
        // 弹出询问弹窗
        showNativePay();
        // 打开收银台地址
        window.open(payUrl, '_blank')
    }).catch(err => {
        emit('payFail');
        console.log(err)
    })
}

// 埋点-试卷[订单生成/支付成功]-上报总数据
const xesTrackPaperOrderCreatePay = () => {
    const params = {
        pay_record_no: payRecordNo.value,
        order_amt: props.paperData?.paperUnitPrice,
        sku_unionid: props.playLoad?.skus?.[0]?.sku_unionid,
        spu_unionid: props.playLoad?.skus?.[0]?.spu_unionid,
        order_spu_num: 1,
        sale_type: '',
        paper_id: props.paperData?.id,
        paper_name: props.paperData?.name,
    };
    return params;
}
// 埋点-会员[订单生成/支付成功]-展开上报spu_id/spu_name/sku_id/sku_name
const xesTrackVipOrderCreatePayInfo = (fn = pcpaperOrderPaid) => {
    confirmDataSku.value?.forEach(e => {
        const params = {
            pay_record_no: payRecordNo.value,
            spu_id: e?.spuId,
            spu_name: e?.productName,
            sku_id: e?.skuId,
            sku_name: e?.skuSpec.map(el => el).join(''),
        };
        fn(params)
    })
}
// 埋点-会员[订单生成/支付成功]-上报总数据
const xesTrackVipOrderCreatePay = () => {
    const coupon = confirmDataPromotion.value?.filter(e => e?.couponId)?.length;
    const saleType =  confirmDataPromotion.value?.length > 0
        ? coupon && coupon < confirmDataPromotion.value?.length ? '优惠券, 活动' : '活动'
        : '';
    const params = {
        order_origin_amt: Number(
            confirmData?.value?.selectedGoodsTotalPrice
        ),
        order_amt: Number(confirmData?.value?.selectedGoodsFinalPrice),
        order_sale_amt: Number(
            confirmData?.value?.discountAmountTotal
        ),
        order_coupon_amt: Number(
            confirmData?.value?.couponAmountTotal
        ),
        order_gift_num: 0,
        order_spu_num: Number(confirmData?.value?.goodsTotalNum),
        pay_record_no: payRecordNo.value,
        sale_type: saleType,
    }
    return params;
}

// 创建订单
const handleDoOrderCreate = (playLoad = {}) => {
    const params = {
        mall_id: 1,
        tal_id: userInfo.value?.tal_id,
        ...playLoad,
    }
    doOrderCreate(params).then(res => {
        if (res?.code) {
			return
		}
		const { pay_record_no = '' } = res?.data || {}
		payRecordNo.value = pay_record_no;
		getPayParams(pay_record_no);
        emit('creatSuccess')

        if (props.goodsType === 1) {
            // 埋点-会员订单生成-上报订单总数据
            const xesTrackInfo = xesTrackVipOrderCreatePay();
            pcpaperOrderPaid(xesTrackInfo)
            // 埋点-会员订单生成-展开上报spu_id/spu_name/sku_id/sku_name
            xesTrackVipOrderCreatePayInfo(pcpaperOrderPaid)
        } else {
            // 埋点-会员订单生成-上报订单总数据
            const xesTrackInfo = xesTrackPaperOrderCreatePay();
            pcpaperOrderPaid(xesTrackInfo)
        }
        
    }).catch(err => {
        console.log(err)
        emit('creatFail')
    })
}
// 权益叠加校验判断
const canPay = () => {
    // 判断剩余履约时长 >=2年（730天）提示不可购买
    if (paperVipInfo.value?.remain_days >= 730){
        let time = getDayOfYear(paperVipInfo.value?.remain_days - 730);
        ElMessage.info(`您的会员有效期天数已达上限，${time}后可进行续费`);
        return false;
    }
    return true;
}

// 获取订单数据
const handleGetConfirmData = async () => {
    if (!canPay()) {
        return;
    }
    emit('handlePay')
    const params = {
        ...props.playLoad,
    }

    getConfirmData(params).then(res => {
        if (res.code || !res.data) {
            return;
        }

        const data = responseToCamelCase(res?.data?.cart_list_info);
        let [skus, promotion] = getGoodsList(
            data?.group,
            true,
            data?.promotionCoupons,
        );
        // 埋点使用数据
        confirmData.value = data;
        confirmDataPromotion.value = promotion || [];
        confirmDataSku.value = skus || [];

        let payload = {
            buyer_words: '',
            skus: requestToSnakeCase(skus),
            promotion: requestToSnakeCase(promotion),
            source: 20, // 20vip会员下单(试卷宝、解题宝)
        };

        // 创建订单
        handleDoOrderCreate(payload)
    }).catch(err => {
        emit('creatFail')
        if(err?.code === 100101) {
            ElMessage.error(err?.message);
            emit('noLogin');
            return;
        }
        if (err?.includes('timeout')) {
            ElMessage.error('请求超时，请稍后再试');
            return;
        }
        if (err === 'Network Error') {
            ElMessage.error('网络不佳，请稍后再试');
            return;
        }
    })
    
}

__expose({
    handlePay
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", {
      class: "pay-btn-box",
      style: _normalizeStyle(_ctx.styleObj),
      onClick: handlePay
    }, [
      _renderSlot(_ctx.$slots, "text")
    ], 4),
    _createVNode(PayStatusDialog, {
      showPayStatus: showPayStatusDialog.value,
      onPaymentResultQuery: paymentResultQuery
    }, null, 8, ["showPayStatus"])
  ], 64))
}
}

})